/**
 * Vendors Catalog JavaScript - Ounass Style
 * Handles tab switching, alphabet navigation, and search functionality
 */

// Vendors Catalog JavaScript
document.addEventListener('DOMContentLoaded', function() {
  // Initialize tabs functionality
  initializeTabs();
  
  // Initialize alphabetical navigation
  initializeAlphabetNav();
  
  // Initialize search functionality
  initializeSearch();
});

// Function to initialize tabs
function initializeTabs() {
  var tabButtons = document.querySelectorAll('.vendors-catalog__tab');
  var tabContents = document.querySelectorAll('.vendors-catalog__content');
  
  tabButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      var targetTab = this.getAttribute('data-tab');
      
      // Remove active class from all tabs and contents
      tabButtons.forEach(function(btn) {
        btn.setAttribute('aria-selected', 'false');
        btn.classList.remove('active');
      });
      
      tabContents.forEach(function(content) {
        content.classList.remove('active');
      });
      
      // Add active class to clicked tab and corresponding content
      this.setAttribute('aria-selected', 'true');
      this.classList.add('active');
      
      var targetContent = document.getElementById('tab-' + targetTab);
      if (targetContent) {
        targetContent.classList.add('active');
        
        // Special handling for categories tab
        if (targetTab === 'categories') {
          initializeCategoriesTab();
        }
      }
    });
  });
}

// Function to initialize categories tab functionality
function initializeCategoriesTab() {
  // Initialize category navigation
  initializeCategoryNavigation();
  
  // Populate all category panels with alphabetical sections
  populateAllCategoryPanels();
}

// Function to populate all category panels with alphabetical sections
function populateAllCategoryPanels() {
  // Get all category panels
  var categoryPanels = document.querySelectorAll('.category-panel[id^="category-brand-"]');
  
  categoryPanels.forEach(function(panel) {
    var categoryId = panel.id;
    var categoryName = categoryId.replace('category-brand-', '');
    
    // Get collections for this category
    var collections = getCollectionsForCategory(categoryName);
    
    if (collections.length > 0) {
      // Populate with alphabetical sections
      populateCategoryWithAlphabeticalSections(panel, categoryName, collections);
    }
  });
}

// Function to populate category panel with alphabetical sections
function populateCategoryWithAlphabeticalSections(panel, categoryName, collections) {
  // Clear existing content
  panel.innerHTML = '';
  
  // Create vendor columns structure similar to "all" category
  var vendorColumns = document.createElement('div');
  vendorColumns.className = 'vendor-columns';
  
  // Create 4 columns
  var columns = ['', '', '', ''];
  var alphabet = ['0-9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
  
  // Distribute alphabet across columns
  alphabet.forEach(function(letter, index) {
    var columnIndex = Math.floor(index / 7); // 7 letters per column (except last column)
    if (columnIndex >= 4) columnIndex = 3; // Ensure we don't exceed 4 columns
    
    var letterSection = document.createElement('div');
    letterSection.className = 'vendor-letter-section';
    letterSection.id = 'category-' + categoryName + '-section-' + letter;
    
    var heading = document.createElement('h3');
    heading.className = 'vendor-letter-heading';
    heading.textContent = letter;
    
    var vendorList = document.createElement('ul');
    vendorList.className = 'vendor-list';
    
    // Filter collections by first letter
    var filteredCollections = filterCollectionsByLetter(collections, letter);
    
    // Add collection links to the list
    filteredCollections.forEach(function(collection) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = collection.url;
      a.textContent = collection.title;
      li.appendChild(a);
      vendorList.appendChild(li);
    });
    
    letterSection.appendChild(heading);
    letterSection.appendChild(vendorList);
    columns[columnIndex] += letterSection.outerHTML;
  });
  
  // Create column divs
  columns.forEach(function(columnContent, index) {
    var columnDiv = document.createElement('div');
    columnDiv.className = 'vendor-column';
    columnDiv.innerHTML = columnContent;
    vendorColumns.appendChild(columnDiv);
  });
  
  panel.appendChild(vendorColumns);
}

// Function to get collections for a specific category
function getCollectionsForCategory(categoryName) {
  var collections = [];
  
  // Get collections from the existing category panel
  var categoryPanel = document.getElementById('category-brand-' + categoryName);
  if (categoryPanel) {
    var collectionElements = categoryPanel.querySelectorAll('.category-vendor-item a');
    
    collectionElements.forEach(function(link) {
      collections.push({
        title: link.textContent.trim(),
        url: link.href
      });
    });
  }
  
  return collections;
}

// Function to filter collections by first letter
function filterCollectionsByLetter(collections, letter) {
  return collections.filter(function(collection) {
    var firstChar = collection.title.charAt(0).toUpperCase();
    
    if (letter === '0-9') {
      return /^[0-9]/.test(collection.title);
    } else {
      return firstChar === letter;
    }
  });
}

// Function to initialize category navigation
function initializeCategoryNavigation() {
  var categoryNavItems = document.querySelectorAll('.category-nav-item');
  var categoryPanels = document.querySelectorAll('.category-panel');
  
  // Set first category as active by default
  if (categoryNavItems.length > 0) {
    var firstCategory = categoryNavItems[0];
    var firstCategoryId = firstCategory.getAttribute('data-category');
    
    // Remove active class from all nav items and panels
    categoryNavItems.forEach(function(navItem) {
      navItem.classList.remove('active');
    });
    
    categoryPanels.forEach(function(panel) {
      panel.classList.remove('active');
    });
    
    // Add active class to first category
    firstCategory.classList.add('active');
    var firstPanel = document.getElementById('category-' + firstCategoryId);
    if (firstPanel) {
      firstPanel.classList.add('active');
      
      // Populate first category with alphabetical sections
      var categoryName = firstCategoryId.replace('brand-', '');
      var collections = getCollectionsForCategory(categoryName);
      if (collections.length > 0) {
        populateCategoryWithAlphabeticalSections(firstPanel, categoryName, collections);
      }
    }
  }
  
  categoryNavItems.forEach(function(item) {
    item.addEventListener('click', function() {
      var targetCategory = this.getAttribute('data-category');
      
      // Remove active class from all nav items and panels
      categoryNavItems.forEach(function(navItem) {
        navItem.classList.remove('active');
      });
      
      categoryPanels.forEach(function(panel) {
        panel.classList.remove('active');
      });
      
      // Add active class to clicked nav item and corresponding panel
      this.classList.add('active');
      
      var targetPanel = document.getElementById('category-' + targetCategory);
      if (targetPanel) {
        targetPanel.classList.add('active');
        
        // Populate with alphabetical sections for all categories
        var categoryName = targetCategory.replace('brand-', '');
        var collections = getCollectionsForCategory(categoryName);
        if (collections.length > 0) {
          populateCategoryWithAlphabeticalSections(targetPanel, categoryName, collections);
        }
      }
    });
  });
}

// Function to initialize All Brands panel with data - removed since "All" tab is removed
function initializeAllBrandsPanel() {
  // This function is no longer needed since "All" tab was removed
  return;
}

// Function to add collection to list - removed since "All" tab was removed
function addCollectionToList(container, collectionTitle) {
  // This function is no longer needed since "All" tab was removed
  return;
}

// Alphabetical navigation functionality
function initializeAlphabetNav() {
  const alphabetLinks = document.querySelectorAll('.alphabet-nav a');
  
  alphabetLinks.forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      
      const targetLetter = this.getAttribute('data-letter');
      const targetSection = document.getElementById('section-' + targetLetter);
      
      if (targetSection) {
        // Smooth scroll to target section
        targetSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
        
        // Highlight the clicked letter
        alphabetLinks.forEach(function(l) {
          l.classList.remove('active');
        });
        this.classList.add('active');
      }
    });
  });
}

// Search functionality
function initializeSearch() {
  const searchInput = document.querySelector('.search-input');
  const searchResults = document.getElementById('search-results');
  
  if (searchInput && searchResults) {
    searchInput.addEventListener('input', function(e) {
      const query = e.target.value.toLowerCase().trim();
      
      if (query.length === 0) {
        searchResults.innerHTML = '';
        return;
      }
      
      // Search through all vendors in the A-Z sections
      const allVendors = getAllVendors();
      const filteredVendors = allVendors.filter(function(vendor) {
        return vendor.toLowerCase().includes(query);
      });
      
      displaySearchResults(searchResults, filteredVendors, query);
    });
  }
}

// Get all vendors from A-Z sections
function getAllVendors() {
  const vendors = [];
  const vendorLinks = document.querySelectorAll('.vendor-list a');
  
  vendorLinks.forEach(function(link) {
    const vendorName = link.textContent.trim();
    if (vendorName && !vendors.includes(vendorName)) {
      vendors.push(vendorName);
    }
  });
  
  return vendors;
}

// Display search results
function displaySearchResults(container, vendors, query) {
  container.innerHTML = '';
  
  if (vendors.length === 0) {
    container.innerHTML = '<p>No vendors found matching "' + query + '"</p>';
    return;
  }
  
  const ul = document.createElement('ul');
  ul.className = 'search-results-list';
  
  vendors.forEach(function(vendor) {
    const li = document.createElement('li');
    const a = document.createElement('a');
    a.href = '/collections/vendors/' + vendor.toLowerCase().replace(/\s+/g, '-');
    a.textContent = vendor;
    li.appendChild(a);
    ul.appendChild(li);
  });
  
  container.appendChild(ul);
}

// Highlight search terms in results
function highlightSearchTerm(text, query) {
  if (!query) return text;
  
  const regex = new RegExp(`(${query})`, 'gi');
  return text.replace(regex, '<strong>$1</strong>');
}

// Smooth scroll to element
function smoothScrollTo(element) {
  if (element) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}

// Add loading state
function showLoading(container) {
  container.innerHTML = '<div class="loading">Loading...</div>';
}

// Add error state
function showError(container, message) {
  container.innerHTML = '<div class="error">' + message + '</div>';
}

// Utility function to debounce search input
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Debounced search function
const debouncedSearch = debounce(function(query) {
  // Perform search with debounced query
  const searchResults = document.getElementById('search-results');
  if (searchResults) {
    const allVendors = getAllVendors();
    const filteredVendors = allVendors.filter(function(vendor) {
      return vendor.toLowerCase().includes(query.toLowerCase());
    });
    
    displaySearchResults(searchResults, filteredVendors, query);
  }
}, 300);

// Add debounced search to input
document.addEventListener('DOMContentLoaded', function() {
  const searchInput = document.querySelector('.search-input');
  if (searchInput) {
    searchInput.addEventListener('input', function(e) {
      const query = e.target.value.trim();
      if (query.length === 0) {
        const searchResults = document.getElementById('search-results');
        if (searchResults) {
          searchResults.innerHTML = '';
        }
        return;
      }
      debouncedSearch(query);
    });
  }
});

// Intersection Observer for alphabet navigation highlighting
function setupAlphabetObserver() {
  const sections = document.querySelectorAll('.vendor-letter-section');
  const links = document.querySelectorAll('.alphabet-nav a');
  
  if (sections.length === 0 || links.length === 0) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const letter = entry.target.id.replace('section-', '');
        
        // Update active alphabet link
        links.forEach(link => {
          link.classList.remove('active');
          if (link.getAttribute('data-letter') === letter) {
            link.classList.add('active');
          }
        });
      }
    });
  }, {
    threshold: 0.3,
    rootMargin: '-20% 0px -70% 0px'
  });

  sections.forEach(section => {
    observer.observe(section);
  });
}

// Initialize alphabet observer when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(setupAlphabetObserver, 500);
});

// Add smooth scrolling behavior
function addSmoothScrolling() {
  const style = document.createElement('style');
  style.textContent = `
    html {
      scroll-behavior: smooth;
    }
  `;
  document.head.appendChild(style);
}

// Initialize smooth scrolling
document.addEventListener('DOMContentLoaded', addSmoothScrolling);

// Smooth scrolling polyfill for older browsers
if (!('scrollBehavior' in document.documentElement.style)) {
  const smoothScrollPolyfill = () => {
    const links = document.querySelectorAll('a[href^="#"]');
    
    links.forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        
        const targetId = this.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);
        
        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  };
  
  document.addEventListener('DOMContentLoaded', smoothScrollPolyfill);
}

// Performance optimization - lazy load vendor sections
function setupLazyLoading() {
  const vendorSections = document.querySelectorAll('.vendor-letter-section');
  
  const lazyLoadObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('loaded');
        lazyLoadObserver.unobserve(entry.target);
      }
    });
  }, {
    rootMargin: '50px'
  });

  vendorSections.forEach(section => {
    lazyLoadObserver.observe(section);
  });
}

// Initialize lazy loading
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(setupLazyLoading, 1000);
});

// Export for global access if needed
window.VendorsCatalog = VendorsCatalog; 